import * as uiConfig from '@mapsight/ui/config';
import createFeatureInteractions from '@mapsight/ui/src/js/config/map/featureInteractions';

import featureSources from './feature-sources';
import mapLayers from './map-layers';
import mapView from './map-view';
import {navPosition} from '../routing/nav-pos';


export default function configIndex(magic, locPathname, locState) {
	const navPos = locPathname ? navPosition(magic, locPathname, locState) : {};
	const config = Object.assign(
		// mapView will be set later by routing.jsx
		uiConfig.map(
			mapLayers(magic, locPathname, locState), mapView, undefined, true,
			createFeatureInteractions({deselectUncontrolledOnClick: ['select']}) // TODO disable deselect on map for Stade
		),
		uiConfig.features(featureSources(magic, locPathname, locState)),
		navPos.app ? uiConfig.featureList( navPos.app.uri, true) : undefined,
	);
	// config.map.interactions = {
	// 	...config.map.interactions,
	// };

	return config;
}
